import { render, staticRenderFns } from "./ServidoresMaisVinculos.vue?vue&type=template&id=10c4b93d"
import script from "./ServidoresMaisVinculos.vue?vue&type=script&lang=js"
export * from "./ServidoresMaisVinculos.vue?vue&type=script&lang=js"
import style0 from "./ServidoresMaisVinculos.vue?vue&type=style&index=0&id=10c4b93d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports